import React from 'react';
import { render } from 'react-dom';
import { Recommendations, ApplicationErrorBoundary } from 'components';
import { Provider } from 'react-redux';
import globalStore from 'state/configure-store';
import { Analytics } from 'packages';
import { LoadingSymbolCards } from 'static/script/components/recommendations/recommendation-loading-spinners';
import { recommendationsV3RequestBuilder } from 'components/recommendations/recommendation-request';
import { inViewport } from 'packages';
import 'components/recommendations/recommendations.scss';

export default initData => {
    const { isLoggedIn } = initData;

    const selector = 'product-recommendations';
    const element = document.getElementById(selector);
    const quickViewEnabled = !!initData.featureSwitches['quick-view'];
    const itemsPerPage = 12;

    const Title = () => (
        <div className="col-12 text-center py-3 mt-4">
            <h2 className="h3 with-asap" data-recommendations-title>
                <strong>
                    {isLoggedIn
                        ? 'Rekommenderat för dig'
                        : 'Trendar på Tradera'}
                </strong>
            </h2>
        </div>
    );

    const trackLoadMoreRecommendations = currentPage => {
        Analytics.trackEvent({
            category: 'Product Recommendations',
            action: 'LoadMore',
            label: `Page: ${currentPage}`
        });
    };

    const LoadmoreButton = () => (
        <div className="col-12 text-center mb-4">
            <a
                data-load-more-recommendations
                role="button"
                className="btn btn-primary btn-wide btn-shadow text-white h5"
                href="/ma/endless-recommendation">
                <div className="row justify-content-between align-items-center">
                    <div className="col" />
                    <div className="col">Visa fler</div>
                    <div className="col d-flex flex-row-reverse">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 16 16">
                            <g fill="none" fillRule="evenodd">
                                <path
                                    fill="#FFFFFF"
                                    fillOpacity=".5"
                                    d="M5.602 0a.4.4 0 0 1 .232.092l7.403 7.654c.155.16.155.32 0 .48L5.834 15.88c-.155.16-.31.16-.465 0l-2.253-2.33c-.155-.16-.155-.32 0-.48l4.917-5.084-4.917-5.084c-.155-.16-.155-.32 0-.48L5.37.092A.4.4 0 0 1 5.602 0z"
                                />
                            </g>
                        </svg>
                    </div>
                </div>
            </a>
        </div>
    );

    if (element) {
        const mount = target =>
            render(
                <ApplicationErrorBoundary>
                    <Provider store={globalStore}>
                        <Recommendations
                            Title={<Title />}
                            itemsPerPage={itemsPerPage}
                            createRequestUrl={recommendationsV3RequestBuilder(
                                'Infinite_scroll_recommendation_slot',
                                itemsPerPage
                            )}
                            LoadingSymbol={
                                <LoadingSymbolCards
                                    itemsPerPage={itemsPerPage}
                                />
                            }
                            itm={{
                                source: 'startpage',
                                medium: 'suggest-from-blueshift'
                            }}
                            collapseIfEmpty={true}
                            enableQuickView={quickViewEnabled}
                            onLoadMore={trackLoadMoreRecommendations}>
                            <LoadmoreButton />
                        </Recommendations>
                    </Provider>
                </ApplicationErrorBoundary>,
                target
            );

        inViewport(`#${selector}`, mount);
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/start-page/startpage-recommendations-mount.js